import { BASE_URL } from "@/config";

export const validatePartnerCode = async (
  code: string,
  walletAddress: string
) => {
  try {
    const response = await fetch(`${BASE_URL}/api/partner-code/validate`, {
      method: "POST",
      body: JSON.stringify({ code, walletAddress }),
      cache: "no-store",
    });

    if (!response.ok) {
      const errorData = await response.json();
      return errorData as {
        message: "USAGE_LIMIT_REACHED" | "INVALID_CODE" | "ALREADY_CLAIMED";
        success: false;
      };
    }

    const responseJson = await response.json();
    return responseJson as {
      success: true;
    };
  } catch (error) {
    console.log("Error during validate partner code -> ", error);
    throw error;
  }
};

export const registerPartnerCode = async (
  code: string,
  walletAddress: string
) => {
  try {
    const response = await fetch(`${BASE_URL}/api/partner-code/register`, {
      method: "POST",
      body: JSON.stringify({ code, walletAddress }),
      cache: "no-store",
    });

    if (!response.ok) {
      const errorData = await response.json();
      return errorData as {
        message: "USAGE_LIMIT_REACHED" | "INVALID_CODE" | "ALREADY_CLAIMED";
        success: false;
      };
    }

    const responseJson = await response.json();
    return responseJson as {
      success: true;
    };
  } catch (error) {
    console.log("Error during validate partner code -> ", error);
    return {
      success: false,
    };
  }
};

type PartnerCodeStatusResponse =
  | {
      hasPartnerCode: true;
      partnerDetails: {
        partnerName: string;
        lightLogoUrl: string;
        darkLogoUrl: string;
        multiplier: number;
      };
    }
  | { hasPartnerCode: false };

export const getPartnerCodeStatus = async (
  walletAddress: string
): Promise<PartnerCodeStatusResponse> => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/partner-code/status?walletAddress=${walletAddress}`,
      {
        cache: "no-store",
      }
    );

    if (!response.ok) return { hasPartnerCode: false };

    const responseJson = await response.json();
    return responseJson;
  } catch (error) {
    console.log("Error during validate partner code -> ", error);
    return { hasPartnerCode: false };
  }
};
